export default [
  { value: 1, name: "Pending" },
  { value: 2, name: "Open" },
  { value: 4, name: "Closed" },
  { value: 8, name: "Cancelled" },
];
